import ImagesPressPartnersBayStartUPSvg from '@/public/images/press/partners/BayStartUP.svg';
import ImagesPressPartnersFreseniusPng from '@/public/images/press/partners/fresenius.png';
import ImagesPressPartnersMunichBusinessSchoolPng from '@/public/images/press/partners/MunichBusinessSchool.png';
import ImagesPressPartnersPioneerLabPng from '@/public/images/press/partners/pioneerLab.png';

export {
  ImagesPressPartnersBayStartUPSvg,
  ImagesPressPartnersFreseniusPng,
  ImagesPressPartnersMunichBusinessSchoolPng,
  ImagesPressPartnersPioneerLabPng,
};
